import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { NftPurchaseContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const PublicBuyNft = () => {

    const { account } = useWeb3React();
    const web3 = useWeb3();
    const tokenAddress = Environment.nftPurchase;
    const contract = NftPurchaseContract(tokenAddress, web3);


    const publicBuyNftHook = useCallback(
        async (catIndex, nftPrice, nftCount, _referrer) => {
            let costPerNft = nftPrice * nftCount;
            const costPerNftInWei = web3.utils.toWei(costPerNft?.toString(), 'ether');

            console.log('payload okokokok', catIndex, nftCount, costPerNft, _referrer, "costPerNftInWei", costPerNftInWei, "costPerNft", costPerNft);

            try {
                let gasPrice = await web3.eth.getGasPrice();
                gasPrice = parseInt(gasPrice) + 5000000000;
                const gas = await contract.methods.purchaseTokens(catIndex, nftCount, _referrer).estimateGas({
                    from: account, value: costPerNft
                });
                const details = await contract.methods.purchaseTokens(catIndex, nftCount, _referrer).send({
                    from: account,
                    value: costPerNft,
                    gas,
                    gasPrice: gasPrice
                });
                return details;
            } catch (error) {
                throw error;
            }
        },
        [contract, account]
    );
    return { publicBuyNftHook: publicBuyNftHook };
};
export default PublicBuyNft;